import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SideNav from "./SideNav";
import Search from "./Search";

import TopHeader from "./TopHeader";
import MobileHeader from "./MobileHeader";
import logo from "../../assets/imgs/main/images.png";

const Header = () => {
  const [navWidth, setNavWidth] = useState(false);
  const [scroll, setScroll] = useState(false);

  const openNav = () => {
    setNavWidth(true);
  };
  const closeNav = () => {
    setNavWidth(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <div className="sub-header ">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-sm-8">
              <div className="left-content">
                <p>
                  This is an educational <em>EDU MEETING </em> Website.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4">
              <div className="right-icons">
                <ul>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-behance"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className={`header-area ${scroll ? "header-sticky" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="main-nav">
                <Link to={"/"} className="logo">
                  Edu Meeting
                </Link>

                <ul className="nav">
                  <li className="scroll-to-section">
                    <Link to={"/"} className="active">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about"}>about us</Link>
                  </li>
                  <li className="scroll-to-section">
                    <Link to={"/courses"}>Courses</Link>
                  </li>
                  <li className="scroll-to-section">
                    <Link to={"/blog"}>Blog</Link>
                  </li>

                  <li className="scroll-to-section">
                    <Link to={"/contact"}>Contact Us</Link>
                  </li>
                </ul>
                <a className="menu-trigger">
                  <span>Menu</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </Fragment>
  );
};

export default Header;
